
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";


export default function ListRolesPage() {
  let params = '';
  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tiêu đề", options: { filter: true, sort: true } },
    { name: "datecreate",label: "Ngày đăng",}
  ];
  
  return (<AkkhorLayout idrole="roles">
    <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Phân quyền
                </li>
            </ul>
        </div>
    <List name="roles" idrole="roles" params={params} title="Quyền hạn" defaultLimit={50}  serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
